import { render, staticRenderFns } from "./InputDateRange.vue?vue&type=template&id=22c89dc4&"
import script from "./InputDateRange.vue?vue&type=script&lang=ts&"
export * from "./InputDateRange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports